export default {
  login: {
    title: '登录',
    tab: '登录',
    tipMessage: {
      part1: '请',
      part2: '注册',
      part3: '(或登录)并',
      part4: '分享',
      part5: '您的偏好，以收到',
      part6: '职位提醒',
      part7: '和职业新闻!'
    },
    btn: {
      findPassword: '忘记密码'
    },
    label: {
      name: '邮箱 / 手机',
      password: '密码'
    },
    message: {
      wrongNameOrPassword: '用户名或密码错误'
    }
  },
  register: {
    employee: {
      title: '员工注册',
      tab: '员工注册',
      tipMessage: {
        part1: '完成注册后我们会向您的邮箱发送一封确认邮件',
        part2: '请注意查收并点击邮件中链接激活您的员工身份。'
      },
      policy: {
        body: '我同意',
        link: '菁客用户协议'
      },
      label: {
        company: '公司',
        name: '姓名',
        email: '邮箱',
        employeeId: '工号',
        password: '创建密码',
        pinCode: '公司邀请码',
        authInfo: '有效信息'
      },
      placeholder: {
        company: '选择你的公司',
        name: '请输入姓名',
        email: '请输入邮箱',
        employeeId: '请输入工号',
        password: '请输入密码',
        pinCode: '请输入公司邀请码',
        authInfo: '请输入有效信息'
      },
      message: {
        invalidEmployeeId: '无效的工号',
        employeeIdNotMatchedEmail: '工号与邮箱不匹配',
        nameNotMatchedEmail: '姓名与邮箱不匹配',
        employeeIdHasBeenUsed: '工号已被使用',
        emailHasBeenUsed: '邮箱已被使用',
        invalidPinCode: '无效的邀请码'
      }
    },
    candidate: {
      title: '注册',
      tab: '注册',
      btn: {
        sendSmsValidateCode: '获取验证码',
        tryAgainAfterTime: '获取验证码({count})'
      },
      label: {
        firstName: '名',
        lastName: '姓',
        email: '邮箱',
        phone: '手机号码',
        password: '创建密码'
      },
      placeholder: {
        phone: '请输入手机号码',
        validateCode: '短信验证码',
        countryCode: '区号'
      },
      policy: {
        body: '我同意',
        link1: '菁客用户协议',
        link2: '菁客隐私政策'
      },
      message: {
        emailHasBeenUsed: '此邮箱地址已被注册',
        invalidSmsValidateCode: '手机号或验证码不正确'
      }
    }
  },
  findPassword: {
    email: {
      label: {
        email: '邮箱',
        captcha: '验证码'
      },
      message: {
        captchaGeneratesFaild: '验证码获取失败，请联系菁客。',
        captchaInvalidOrExpired: '图形验证码无效或已失效，请刷新图形验证码！',
        emailNoRegister: '此邮箱未被注册',
        sendEmailSuccess: '我们已经给您发送了邮件，请查看邮件里的信息。'
      }
    }
  }
}
